import type { StoneFlickingCoreConfig } from "@cloudnest/stone-flicking-core-engine/types";
import type { StoneFlickingConfig } from "../types/game-config";

export function buildCoreConfig(
  config: StoneFlickingConfig,
): StoneFlickingCoreConfig {
  return {
    space: config.board,
    dynamics: config.dynamics,
    archetypes: config.pieces,
    maxTurns: config.maxTurns,
    impulseAccuracy: {
      power: config.accuracy.power,
      direction: config.accuracy.direction,
      directionMaxErrorDeg: config.accuracy.directionMaxErrorDeg,
    },
  };
}
